import getActiveRetentionPolicyTagsOperation from 'owa-service/lib/operation/getActiveRetentionPolicyTagsOperation';
import GetRetentionPolicyTagsResponse from 'owa-service/lib/contract/GetRetentionPolicyTagsResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Service to get list of active policies
 */
export default function getActivePolicies(): Promise<GetRetentionPolicyTagsResponse> {
    return getActiveRetentionPolicyTagsOperation({
        Header: getJsonRequestHeader(),
    });
}
